import LoyaltyTierLabel from 'components/Common/Labels/LoyaltyTierLabel'
import LayoutContainer from 'components/Common/LayoutContainer'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import TextButton from 'LuxKit/Button/TextButton'
import Heading from 'LuxKit/Typography/Heading'
import Colour from 'components/utils/Colour'
import Group from 'components/utils/Group'
import { useAppSelector } from 'hooks/reduxHooks'
import LoyaltyProgramNameLogo from 'loyalty/components/LoyaltyProgramNameLogo'
import { rem } from 'polished'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

const HeroSection = styled.div`
  padding: ${rem(60)} 0;
  background: ${props => props.theme.palette.product.loyalty.silver.gradientPrimaryBackground};
`

interface Props {
  onActivate?: () => void
}

function LoyaltyUserSilverHero(props: Props) {
  const { onActivate } = props
  const intl = useIntl()
  const firstName = useAppSelector(state => state.auth.account.givenName)

  const exclusiveInviteLabel = intl.formatMessage({
    id: 'aGW174sWiO',
    defaultMessage: 'EXCLUSIVE INVITE',
    description: 'Tier label for exclusive silver invite on loyalty user page',
  })

  const congratulationsHeading = intl.formatMessage({
    id: 'gVKd4CjpXm',
    defaultMessage: 'Congratulations, you\u2019re been fast tracked to Silver as a thank you for being one of our valued customers.',
    description: 'Subheading congratulating user on silver tier fast track',
  })

  const activateMembershipCta = intl.formatMessage({
    id: 'cZG2yUm/Vw',
    defaultMessage: 'Activate your free membership',
    description: 'CTA button to activate free loyalty membership on silver hero',
  })

  return <HeroSection>
    <LayoutContainer variant="medium">
      <VerticalSpacer gap={16} style={{ position: 'relative' }}>
        <Group direction="horizontal" gap={12} verticalAlign="center">
          <LoyaltyProgramNameLogo width={104} />
          <LoyaltyTierLabel kind="primary" tier="silver">
            {exclusiveInviteLabel}
          </LoyaltyTierLabel>
        </Group>
        <Group
          direction="vertical"
          tabletDirection="horizontal"
          tabletHorizontalAlign="space-between"
          gap={24}
          tabletGap={16}
        >
          <VerticalSpacer gap={16}>
            <Heading variant="heading1" format="propercase">
              {firstName && <FormattedMessage
                id="9v+D8XmSjT"
                defaultMessage="<italic>{firstName}</italic>, you've unlocked{br}<tierColour>Silver status</tierColour>"
                description="Loyalty silver hero heading with user name showing they unlocked silver status"
                values={{
                  firstName,
                  italic: (chunks) => <i>{chunks}</i>,
                  br: <br />,
                  tierColour: (chunks) => <Colour value="tier-silver-light-contrast">{chunks}</Colour>,
                }}
              />}
              {!firstName && <FormattedMessage
                id="NFlpSMkSFS"
                defaultMessage="You've unlocked{br}<tierColour>Silver status</tierColour>"
                description="Loyalty silver hero heading without user name showing they unlocked silver status"
                values={{
                  br: <br />,
                  tierColour: (chunks) => <Colour value="tier-silver-light-contrast">{chunks}</Colour>,
                }}
              />}
            </Heading>
            <Heading variant="heading4">
              {congratulationsHeading}
            </Heading>
          </VerticalSpacer>
          <Group
            direction="vertical"
            horizontalAlign="start"
            tabletHorizontalAlign="end"
            tabletVerticalAlign="end"
          >
            <TextButton kind="primary" onClick={onActivate}>
              {activateMembershipCta}
            </TextButton>
          </Group>
        </Group>
      </VerticalSpacer>
    </LayoutContainer>
  </HeroSection>
}

export default LoyaltyUserSilverHero
